/**
 * HUD — DOM-based perf overlay. Cheap to update; we only push text every frame
 * but it's a noop-cost because textContent doesn't trigger reflow.
 */

export interface HudRefs {
  fps: HTMLElement;
  nodes: HTMLElement;
  scale: HTMLElement;
  dpr: HTMLElement;
  res: HTMLElement;
  compile: HTMLElement;
}

export function bindHud(): HudRefs {
  const $ = (id: string) => {
    const el = document.getElementById(id);
    if (!el) throw new Error("HUD element missing: " + id);
    return el;
  };
  return {
    fps: $("hud-fps"),
    nodes: $("hud-nodes"),
    scale: $("hud-scale"),
    dpr: $("hud-dpr"),
    res: $("hud-res"),
    compile: $("hud-compile"),
  };
}

export function updateHud(hud: HudRefs, state: {
  fps: number;
  nodes: number;
  scale: number;
  dpr: number;
  w: number;
  h: number;
  compileMs: number;
}): void {
  hud.fps.textContent = state.fps.toFixed(0);
  hud.nodes.textContent = state.nodes.toString();
  hud.scale.textContent = state.scale.toFixed(2);
  hud.dpr.textContent = state.dpr.toFixed(2);
  hud.res.textContent = `${state.w}×${state.h}`;
  hud.compile.textContent = state.compileMs.toFixed(2);
}
